import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { loginUser, getMe } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('tsela_token');
    if (!token) { setLoading(false); return; }
    getMe()
      .then(res => setUser(res.data))
      .catch(() => localStorage.removeItem('tsela_token'))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (username, password) => {
    const { data: { access_token } } = await loginUser(username, password);
    localStorage.setItem('tsela_token', access_token);
    const { data: me } = await getMe();
    setUser(me);
    return me;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('tsela_token');
    setUser(null);
  }, []);

  // Convenience helper: returns true if the current user can access a feature.
  // Admin always returns true. General users check their permissions object.
  const can = useCallback((feature) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    return user.permissions?.[feature] === true;
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
